import cx from 'classnames';
import { Link } from 'gatsby';
import React from 'react';

const PartnershipsExpandedNav = ({ open }) => {
  return (
    <div className={cx('partnerships-expanded-nav', { open })}>
      <div className="partnerships-expanded-nav__container">
        <hr />
        <div className="partnerships-expanded-nav__list">
          <Link to="/partnerships/fiverr/">fiverr</Link>
          <Link to="/partnerships/mailchimp/">Mailchimp</Link>
          <div className="partnerships-expanded-nav__mailchimp">
            <Link to="/partnerships/mailchimp/">
              Five keys to driving online sales
            </Link>
            <Link to="/partnerships/mailchimp/1/">1. Get the basics right</Link>
            <Link to="/partnerships/mailchimp/2/">
              2. Drive traffic to your site
            </Link>
            <Link to="/partnerships/mailchimp/3/">
              3. Manage – and build – your audience
            </Link>
            <Link to="/partnerships/mailchimp/4/">
              4. Increase sales and customer retention
            </Link>
            <Link to="/partnerships/mailchimp/5/">
              5. Maximise what’s working
            </Link>
          </div>
          <Link to="/partnerships/zettle/">Zettle</Link>
          <Link to="/partnerships/instagram/">Instagram</Link>
        </div>
      </div>
    </div>
  );
};

export default PartnershipsExpandedNav;
